import {
  Avatar,
  Badge,
  Box,
  Flex,
  Grid,
  GridItem,
  HStack,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react';
import { BsQuestionCircle } from 'react-icons/bs';
import { HelivanColor } from '../../helivan/HelivanColor';
import { getSimilarityStyle } from '../ProjectTabViewFaq';
import {
  DEMO_ASH,
  DEMO_INSPECT_EARLIER_LABEL,
  DEMO_INSPECT_ROWS,
} from './demoWatch';

// The Inspect tab for the demo watch. Mirrors the real comparison view
// (ProjectTabViewFaq) but with fixed sample rows — one per similarity color —
// so it needs no Apollo / OpenAI similarity query.
export const DemoInspect = () => {
  return (
    <Box width="full" maxWidth="900px" px={{ base: 3, md: 0 }}>
      <VStack spacing={4} width="full" align="stretch">
        {/* Column headers: current vs earlier check-in */}
        <Grid templateColumns="1fr 1fr" gap={4}>
          <GridItem>
            <HStack spacing={3} p={3} bg={HelivanColor.hover.lightBlue} borderRadius="8px">
              <Avatar size="sm" bg="white" name={DEMO_ASH.name} color={HelivanColor.text.helivanBlue} />
              <VStack align="start" spacing={0}>
                <Text fontSize="13px" fontWeight="600" color={HelivanColor.text.blueDark}>
                  Current
                </Text>
                <Text fontSize="11px" color={HelivanColor.text.blueMid}>
                  {DEMO_INSPECT_ROWS.length} responses
                </Text>
              </VStack>
            </HStack>
          </GridItem>
          <GridItem>
            <HStack spacing={3} p={3} bg={HelivanColor.hover.lightBlue} borderRadius="8px">
              <Avatar size="sm" bg="white" name={DEMO_ASH.name} color={HelivanColor.text.helivanBlue} />
              <VStack align="start" spacing={0}>
                <Text fontSize="13px" fontWeight="600" color={HelivanColor.text.blueDark}>
                  {DEMO_INSPECT_EARLIER_LABEL}
                </Text>
                <Text fontSize="11px" color={HelivanColor.text.blueMid}>earlier check-in</Text>
              </VStack>
            </HStack>
          </GridItem>
        </Grid>

        {DEMO_INSPECT_ROWS.map((item, idx) => {
          const sim = getSimilarityStyle(item.similarity);
          return (
            <Box
              key={idx}
              bg="white"
              border="1px solid"
              borderColor={HelivanColor.border.primary}
              borderLeft="4px solid"
              borderLeftColor={sim.border}
              borderRadius="12px"
              overflow="hidden"
            >
              <Flex
                p={4}
                bg={HelivanColor.background.secondary}
                borderBottom="1px solid"
                borderBottomColor={HelivanColor.border.primary}
                alignItems="center"
                gap={3}
                justifyContent="space-between"
              >
                <HStack alignItems="flex-start" gap={3}>
                  <Flex
                    width="28px"
                    height="28px"
                    borderRadius="6px"
                    bg={HelivanColor.hover.lightBlue}
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                  >
                    <BsQuestionCircle size={14} color={HelivanColor.text.helivanBlue} />
                  </Flex>
                  <Text fontSize="14px" fontWeight="500" color={HelivanColor.text.blueDark} lineHeight="1.5">
                    {item.question}
                  </Text>
                </HStack>
                <Tooltip
                  label={
                    item.answerA && item.answerB
                      ? 'Semantic similarity of the two answers'
                      : 'One version has no answer for this question'
                  }
                  hasArrow
                  placement="top"
                >
                  <Badge colorScheme={sim.scheme} flexShrink={0} fontSize="11px">
                    {sim.label}
                  </Badge>
                </Tooltip>
              </Flex>
              <Grid templateColumns="1fr 1fr" gap={0}>
                <GridItem p={4} borderRight="1px solid" borderRightColor={HelivanColor.border.primary}>
                  <Text fontSize="14px" color={item.answerA ? HelivanColor.text.blueDark : HelivanColor.text.gray} lineHeight="1.6">
                    {item.answerA ?? 'No response in this version'}
                  </Text>
                </GridItem>
                <GridItem p={4}>
                  <Text fontSize="14px" color={item.answerB ? HelivanColor.text.blueDark : HelivanColor.text.gray} lineHeight="1.6">
                    {item.answerB ?? 'No response in this version'}
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
};
